import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTrendmicroComponent } from './simple-icons-trendmicro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTrendmicroComponent ],
    exports:      [ SimpleIconsTrendmicroComponent ],
    bootstrap:    []
})
export class SimpleIconsTrendmicroModule {}
